/*******************************************************************************
TRIGGER THE FILTER RANGE UI
Handles a click on the filter range edit button.
*******************************************************************************/

export default function updateRangeEditor(e) {
    const $filterRangeEditor = $(e.currentTarget).parents('.filter-range__editor');
    const $startSelBox = $filterRangeEditor.find('.is-start');
    const $endSelBox = $filterRangeEditor.find('.is-end');
    const $button = $filterRangeEditor.find('.filter-range__go');

    // Get the current URL's params
    const params = new URLSearchParams(window.location.search);

    // Grab the selected start and end values
    const start = $startSelBox.val();
    const end = $endSelBox.val();

    // Get the URL param names to use
    const startName = $startSelBox.data('name') || 'start';
    const endName = $endSelBox.data('name') || 'end';

    // Find the defaults + single unit label
    const defaultStart = $filterRangeEditor.data('defaultStart') || '';
    const defaultEnd = $filterRangeEditor.data('defaultEnd') || '';
    const singleName = $filterRangeEditor.data('single') || null;

    // Update the start/end values in the URL parameters array
    if (singleName && start === end) {
        params.set(singleName, start);
        params.delete(startName);
        params.delete(endName);
    }
    else {
        params.set(startName, start);
        params.set(endName, end);
    }

    // If the default values match the start or end, omit their respective URL params
    if (Number(defaultStart) === Number(start)) { params.delete(startName); }
    if (Number(defaultEnd) === Number(end)) { params.delete(endName); }

    // Sort the params so they're in alphabetical order (for URL consistency)
    params.sort();

    // Build the updated link
    const paramsLength = Array.from(params).length;
    const qMark = (paramsLength !== 0) ? '?' : '';
    const updatedLink = `${window.location.pathname}${qMark}${params}`;

    // Update the "go" button link
    $button.attr('href', updatedLink);
}
